export const fixApSubjectTestValues = (data:any) => {
    if (data && data.ap_test_array && data.ap_test_array.length>0) {
        for(let i=0; i< data.ap_test_array.length; i++) {
            let item:any = data.ap_test_array[i];
            item.subject = ''; // force clear unused subject
            if (item.subjectCM) {
                switch(item.subjectCM.toLowerCase()) {
                    case 'english language and composition':
                        item.subjectCM = 'English Language & Composition';
                        break;
                    case 'english literature and composition':
                        item.subjectCM = 'English Literature & Composition';
                        break;
                    case 'government and politics: comparative':
                        item.subjectCM = 'Government & Politics: Comparative';
                        break;
                    case 'government & politics: united states':
                        item.subjectCM = 'Government & Politics: United States';
                        break;
                    case 'italian language and culture':
                        item.subjectCM = 'Italian Language & Culture';
                        break;   
                    case 'japanese language and culture':
                        item.subjectCM = 'Japanese Language & Culture';
                        break;
                    case 'physics c - electricity and magnetism':
                        item.subjectCM = 'Physics C - Electricity & Magnetism';
                        break;                      

                }
            }
        }
    }

}

export const fixCourseConfigValues = (data:any) => {
    if (data && data.subjectDetails && data.subjectDetails.length>0) {
        for(let i=0; i< data.subjectDetails.length; i++) {
            let item = data.subjectDetails[i];
            fixCourseValues(item);          
        }
    }
}
export const fixCourseValues = (item:any) => {
    if (item && item.AGSubjectArea && item.subject) {
        switch(item.AGSubjectArea){
            case 'A History / Social Science':
                switch(item.subject.toLowerCase()) {
                    case `Civics / American Government`.toLowerCase():
                        item.subject = 'Civics/American Government';
                        break;
                    case `World History / Cultures / Historical Geography`.toLowerCase():
                        item.subject = 'World History/Cultures/Hist. Geography';
                        break;
                }
                break;
            case 'B English':
                switch(item.subject.toLowerCase()) {
                    case `English as a Second Language (ESL) / English Language Development (ELD)`.toLowerCase():
                        item.subject = 'English-ESL/ELD';
                        break;
                }
                break;
            case 'C Mathematics':
                switch(item.subject.toLowerCase()) {
                    case `Algebra II / Trigonometry`.toLowerCase():
                        item.subject = 'Algebra II/Trigonometry';
                        break;
                }
                break;
            case 'D1 - Biological Science':
            case 'D2 - Physical Science':
            case 'D Science':
                switch(item.subject.toLowerCase()) {
                    case `Biology / Earth & Space Sciences`.toLowerCase():
                    case `Biology / Earth and Space Sciences`.toLowerCase():
                    case `Biology/Earth and Space Sciences`.toLowerCase():
                    case `Biology/Earth & Space Sciences`.toLowerCase():
                        item.subject = 'Biology/Earth & Space Sciences';
                        break;
                    case `Biology / Life Sciences`.toLowerCase():
                    case `Biology/Life Sciences`.toLowerCase():
                        item.subject = 'Biology/Life Sciences';
                        break;
                    case `Chemistry / Earth & Space Sciences`.toLowerCase():
                    case `Chemistry / Earth and Space Sciences`.toLowerCase():
                    case `Chemistry/Earth and Space Sciences`.toLowerCase():
                    case `Chemistry/Earth & Space Sciences`.toLowerCase():
                        item.subject = 'Chemistry/Earth & Space Sciences';
                        break;
                    case `Earth and Space Sciences`.toLowerCase():
                    case `Earth & Space Sciences`.toLowerCase():
                        item.subject = 'Earth & Space Sciences';
                        break;
                    case `Physics / Earth and Space Sciences`.toLowerCase():
                    case `Physics / Earth & Space Sciences`.toLowerCase():
                    case `Physics/Earth and Space Sciences`.toLowerCase():
                    case `Physics/Earth & Space Sciences`.toLowerCase():
                        item.subject = 'Physics/Earth & Space Sciences';
                        break;
                }
                break;
            case 'G College-Preparatory Elective':
                switch(item.subject.toLowerCase()) {
                    case `English`.toLowerCase():
                        item.subject = 'Elective - English';
                        break;
                    case `English as a Second Language (ESL) / English Language Development (ELD)`.toLowerCase():
                        item.subject = 'Elective - ESL/ELD';
                        break;
                    case `History / Social Science`.toLowerCase():
                    case `History/Social Science`.toLowerCase():
                        item.subject = 'Elective - History/Social Science';
                        break;
                    case `Interdisciplinary`.toLowerCase():
                        item.subject = 'Elective - Interdisciplinary';
                        break;
                    case `Interdisciplinary Sciences`.toLowerCase():
                        item.subject = 'Elective - Interdisciplinary Sciences';
                        break;
                    case `Language Other than English`.toLowerCase():
                        item.subject = 'Elective - Language Other than English';
                        break;
                    case `Mathematics`.toLowerCase():
                        item.subject = 'Elective - Mathematics';
                        break
                    case `Mathematics - Computer Science`.toLowerCase():
                        item.subject = 'Elective - Math-Computer Science';
                        break;
                    case `Science – Biology / Life Sciences`.toLowerCase():
                    case `Science - Biology / Life Sciences`.toLowerCase():
                    case `Science - Biology/Life Sciences`.toLowerCase():
                        item.subject = 'Elective - Science - Biology/Life Sciences';
                        break;
                    case `Science – Integrated Science`.toLowerCase():
                    case `Science - Integrated Science`.toLowerCase():
                        item.subject = 'Elective - Science - Integrated Science';
                        break;
                    case `Science – Physical Sciences`.toLowerCase():
                    case `Science - Physical Sciences`.toLowerCase():
                        item.subject = 'Elective - Science - Physical Science';
                        break;
                    case `Visual & Performing Arts`.toLowerCase():
                        item.subject = 'Elective - Visual & Performing Arts';
                        break;
                    default:
                        switch(item.subject) {
                            case 'Elective -English':
                                item.subject = 'Elective - English';
                                break;
                            case 'Elective -ESL/ELD':
                                item.subject = 'Elective - ESL/ELD';
                                break;
                            case 'Elective -History/Social Science':
                                item.subject = 'Elective - History/Social Science';
                                break;
                            case 'Elective -Interdisciplinary':
                                item.subject = 'Elective - Interdisciplinary';
                                break;
                            case 'Elective -Language Other than English':
                                item.subject = 'Elective - Interdisciplinary Sciences';
                                break;
                            case 'Elective -Mathematics':
                                item.subject = 'Elective - Mathematics';
                                break;
                            case 'Elective -Math -Computer Science':
                            case 'Elective -Math - Computer Science':
                            case 'Elective -Math-Computer Science':
                                item.subject = 'Elective - Math-Computer Science';
                                break;
                            case 'Elective -Science-Biology/Life Sciences':
                                item.subject = 'Elective - Science - Biology/Life Sciences';
                                break;
                            case 'Elective -Science-Integrated Science':
                                item.subject = 'Elective - Science - Integrated Science';
                                break;
                            case 'Elective -Science-Physical Science':
                                item.subject = 'Elective - Science - Physical Science';
                                break;
                            case 'Elective -Visual & Performing Arts':
                                item.subject = 'Elective - Visual & Performing Arts';
                                break;
                        }
                }
                break;
            case 'E Language Other than English':
                switch(item.subject) {
                    case 'LOTE Level 1':
                        item.subject = 'Yr 1 Lang Other Than English';
                        break;
                    case 'LOTE Level 2':
                        item.subject = 'Yr 2 Lang Other Than English';
                        break;
                    case 'LOTE Level 3':
                        item.subject = 'Yr 3 Lang Other Than English';
                        break;    
                    case 'LOTE Level 4+':
                        item.subject = 'Yr 4+ Lang Other Than English';
                        break;
                }
                break;

        }
    }
}


export const mapAGSumaryCalculation = (data:any) => {
    if (data && data.subjectDetails && data.subjectDetails.length>0) {
        for(let i=0; i< data.subjectDetails.length; i++) {
            let item = data.subjectDetails[i];
            mapAGSumary_Value(item);          
        }
    }
}


export const mapAGSumary_Value = (item:any) => {
    if (item && item.AGSubjectArea && item.subject) {
        switch(item.AGSubjectArea){
            case 'D Science':
                switch(item.subject.toLowerCase()) {
                    case `Applied Science`.toLowerCase():
                        item.AGSubjectArea = 'D1 - Biological Science';
                        break;
                    case `Biology / Life Sciences`.toLowerCase():
                    case `Biology/Life Sciences`.toLowerCase():
                        item.subject = 'Biology/Life Sciences';
                        item.AGSubjectArea = 'D1 - Biological Science';
                        break;
                    case `Biology / Earth & Space Sciences`.toLowerCase():
                    case `Biology / Earth and Space Sciences`.toLowerCase():
                    case `Biology/Earth and Space Sciences`.toLowerCase():
                    case `Biology/Earth & Space Sciences`.toLowerCase():
                        item.subject = 'Biology/Earth & Space Sciences';
                        item.AGSubjectArea = 'D1 - Biological Science';
                        break;
                    case `Chemistry`.toLowerCase():
                        item.AGSubjectArea = 'D2 - Physical Science';
                        break;
                    case `Chemistry / Earth & Space Sciences`.toLowerCase():
                    case `Chemistry / Earth and Space Sciences`.toLowerCase():
                    case `Chemistry/Earth and Space Sciences`.toLowerCase():
                    case `Chemistry/Earth & Space Sciences`.toLowerCase():
                        item.subject = 'Chemistry/Earth & Space Sciences';
                        item.AGSubjectArea = 'D2 - Physical Science';
                        break;
                    case `Computer Science`.toLowerCase():
                        item.AGSubjectArea = 'C Mathematics';
                        break;
                    case `Earth and Space Sciences`.toLowerCase():
                    case `Earth & Space Sciences`.toLowerCase():
                        item.subject = 'Earth & Space Sciences';
                        item.AGSubjectArea = 'D2 - Physical Science';
                        break;
                    case `Engineering`.toLowerCase():
                        item.AGSubjectArea = 'D2 - Physical Science';
                        break;
                    case `Integrated Science`.toLowerCase():
                    case `Integrated Science 1`.toLowerCase():
                        item.AGSubjectArea = 'D1 - Biological Science';
                        break;
                    case `Integrated Science 2`.toLowerCase():
                    case `Integrated Science 3`.toLowerCase():
                        item.AGSubjectArea = 'D2 - Physical Science';
                        break;
                    case `Interdisciplinary Sciences`.toLowerCase():
                        item.AGSubjectArea = 'D1 - Biological Science';
                        break;
                    case `Physics`.toLowerCase():
                        item.AGSubjectArea = 'D2 - Physical Science';
                        break;
                    case `Physics / Earth and Space Sciences`.toLowerCase():
                    case `Physics / Earth & Space Sciences`.toLowerCase():
                    case `Physics/Earth and Space Sciences`.toLowerCase():
                    case `Physics/Earth & Space Sciences`.toLowerCase():
                        item.subject = 'Physics/Earth & Space Sciences';
                        item.AGSubjectArea = 'D2 - Physical Science';
                        break;
                }
                break;
            case 'E Language Other than English':
                switch(item.subject) {
                    case 'LOTE Level 1':
                        item.subject = 'Yr 1 Lang Other Than English';
                        break;
                    case 'LOTE Level 2':
                        item.subject = 'Yr 2 Lang Other Than English';
                        break;
                    case 'LOTE Level 3':
                        item.subject = 'Yr 3 Lang Other Than English';
                        break;    
                    case 'LOTE Level 4+':
                        item.subject = 'Yr 4+ Lang Other Than English';
                        break;
                }
                break;
    
        }
    }
}